<div class="my-searches">
	<div *ngIf="mysearches && mysearches.length > 0">
	    <div class="mysearches-pagination-container">
			<div class="text-center" *ngIf="pagination.totalElements > pagination.elementsPerPage">
				  <ngb-pagination class="pagination custom-page pagination-sm"
				    [(page)]="pagination.page" 
				    [pageSize]="pagination.elementsPerPage"
				    [collectionSize]="pagination.totalElements" 
				    (pageChange)="pagination.pageChanged($event)"
				    [maxSize]="3"
				    [boundaryLinks]="true"
				    previousText="&#xf053;"
				    nextText="&#xf054;"
				    firstText="&#xf053;&#xf053;"
				    lastText="&#xf054;&#xf054;">
				  </ngb-pagination>					
			</div>
	    </div>    
	    <div *ngFor='let search of mysearches; let i = index;' class="item-hover">
	        <div class="section">
	            <div class="row" style="margin:0px">
	                <div class="col-sm-8 truncate" title="{{search.name}}">
	                    <div class="truncate text-left main-label">{{search.name}}</div>
	                    <div class="sub-section text-muted">
	                        <span>{{search.createdDate}} </span>
	                        <span class="pull-left" style="padding-right:8px;">
	                        	<i class="fas fa-info-circle pointMe" title="{{LOCALIZATION.viewDetails}}" (click)="toggleExpand(i)"></i>
	                		</span>
	                    </div>
	                </div>
	                <div class="col-sm-4 text-right">
	                    <button class="btn btn-sm btn-primary" 
	                    	title="{{LOCALIZATION.searchClick}}"
	                        (click)="executeSearch(search); $event.stopPropagation();">
	                            <i class="fas fa-search" aria-hidden="true"></i>
	                    </button>
	                </div>
	            </div>
	        </div>
	        <!-- Expandable section -->
	        <div *ngIf="expandedStates[i]" class="well" style="word-wrap:break-word;margin:5px;">
	            <div><span class="sub-label">{{LOCALIZATION.name}}: </span><span>{{search.name}}</span></div>
	            <div><span class="sub-label">{{LOCALIZATION.created}}: </span><span>{{search.created}}</span></div>
	            <div class="truncate">
	            	<span class="sub-label">{{LOCALIZATION.query}}: </span>
	            	<span title="{{search.dataObj.query}}">{{search.dataObj.query}}</span>
	            </div>
	            <div>
	            	<span class="sub-label">{{LOCALIZATION.type}}: </span>
	            	<span title="{{search.dataObj.type}}">{{search.dataObj.type}}</span>
	            </div>
	            <div *ngIf="search.dataObj.aoi" class="truncate">
	            	<span class="sub-label">{{LOCALIZATION.boundedTo}}: </span>
	            	<span title="{{search.dataObj.aoi}}">{{search.dataObj.aoi}}</span>
	            </div>
				<div *ngFor="let entry of search.dataObj.criteria | keyvalue">
				    <span class="sub-label">{{ entry.value.display_header }}: </span>
				    <span title="{{ entry.value.display_value }}">{{ entry.value.display_value }}</span>
				</div>
	        </div>
	    </div>
    </div>
    <div *ngIf="mysearches && mysearches.length == 0"><i>{{LOCALIZATION.savedSearchesEmpty}}</i></div>
</div>
            